import axios from "axios";
import { useState } from "react";
import { useHistory } from "react-router";
import { Container, Form, Button, Alert } from "react-bootstrap";
import { Link } from "react-router-dom";

function ResetPassword(props) {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const [password, setPassword] = useState();
  const [confirmPassword, setConfirmPassword] = useState();
  const [errorMessage, setErrorMessage] = useState("");
  const [errorMessageDetail, setErrorMessageDetail] = useState("");
  const [isLoading, setLoading] = useState(false);
  const history = useHistory();
  const { code } = props;

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    axios
      .post(API_URL + "/auth/reset-password", {
        code: code,
        password: password,
        passwordConfirmation: confirmPassword,
      })
      .then((res) => {
        console.log(res);
        history.push("/");
      })
      .catch((error) => {
        setLoading(false);
        console.log("Error with reset password:", error.response);
        setErrorMessage("Hubo un error, intente nuevamente.");
        const { status, name, message } = error.response.data.error;
        setErrorMessageDetail(`(${status}) ${message}`);
      });
  };

  return (
    <Container
      id="main-container"
      className="p-3 mb-4 d-grid h-100 bg-light rounded-3"
    >
      {!code ? (
        <Alert variant="danger">
          Datos inválidos, debe ingresar desde el link de su email ó intente
          volver a generarlo <Link to="/forgot-password"> aqui </Link>
        </Alert>
      ) : (
        <>
          <p>A continuación ingrese su nueva contraseña.</p>
          <Form
            id="sign-in-form"
            className="text-center w-100"
            onSubmit={(e) => handleSubmit(e)}
          >
            <Form.Group className="mb-3" controlId="formPassword">
              <Form.Label>Contraseña</Form.Label>
              <Form.Control
                size="lg"
                type="password"
                placeholder="Contraseña"
                onChange={(e) => setPassword(e.target.value)}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="formConfirmPassword">
              <Form.Label>Repita Contraseña</Form.Label>
              <Form.Control
                size="lg"
                type="password"
                placeholder="Repita Contraseña"
                onChange={(e) => setConfirmPassword(e.target.value)}
              />
            </Form.Group>
            <Button variant="primary" type="submit" disabled={isLoading}>
              {isLoading ? "Procesando…" : "Reiniciar contraseña"}
            </Button>
            {errorMessage ? (
              <Alert className="mt-3" variant="danger">
                <Alert.Heading>{errorMessage}</Alert.Heading>
                <p>{errorMessageDetail}</p>
              </Alert>
            ) : (
              <></>
            )}
          </Form>
        </>
      )}
    </Container>
  );
}
export default ResetPassword;
